import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StaffMapTrackingComponent } from './components/staff-map-tracking.component';


const routes: Routes = [
  {
    path: ':id',
    component: StaffMapTrackingComponent,
    data: { preload: true }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StaffMapTrackingRoutingModule { }
